import Layout from '../../components/Layout';
import PageHeadline from '../../components/PageHeadline';
import SocialMedias from '../../components/SocialMedias';
import LoginForm from '../../components/Forms/LoginForm';
import React, {useState} from 'react';
import {loginUserErrorReset} from 'store/actions/userActions';
import {useDispatch, useSelector} from 'react-redux';
import {useCallback, useEffect} from 'react';
import {Redirect} from 'react-router-dom';
import * as actions from 'store/actions';
import {preventDefaultDrag} from 'Utils/utils';
import FullPageSpinner from 'SmallLayoutComponents/FullPageSpinner';
import ForgotPassword from '../../components/Forms/ForgotPassword';

const LoginEvent = () => {
    const dispatch = useDispatch();

    //redux
    const languages = useSelector((state) => state.languages);
    const defaultTranslation = useSelector((state) => state.languages.translations['en']);
    const translation = useSelector((state) => state.languages.translations[state.languages.eventLanguage]);
    const loadingEvent = useSelector((state) => state.event.loading);
    const eventInfo = useSelector((state) => state.event.eventInfo);
    const eventId = useSelector((state) => state.event.eventId);

    //states
    const [userExistButNotLoggedIn, setUserExistButNotLoggedIn] = useState(false);
    const [brandingTranslation, setBrandingTranslation] = useState(null);
    const [showRecoverPasswordDialog, setShowRecoverPasswordDialog] = useState(false);
    const [passwordSent, setPasswordSent] = useState({success: false, email: ''});
    const [preRegistrationData, setPreRegistrationData] = useState(null);

    const loginScreenStepsTitles = [
        {
            heading:
                translation.newLoginRegistrations.joinTheEvent || defaultTranslation.newLoginRegistrations.joinTheEvent,
            subHeading:
                translation.newLoginRegistrations.joinTheEventSub ||
                defaultTranslation.newLoginRegistrations.joinTheEventSub,
        },
        {
            heading:
                translation.newLoginRegistrations.headingUser || defaultTranslation.newLoginRegistrations.headingUser,
            subHeading:
                translation.newLoginRegistrations.subHeadingUser ||
                defaultTranslation.newLoginRegistrations.subHeadingUser,
        },
    ];
    const forgotPasswordTitlesEvent = [
        {
            heading:
                translation.newLoginRegistrations.forgotPasswordHeadline ||
                defaultTranslation.newLoginRegistrations.forgotPasswordHeadline,
            subHeading:
                translation.newLoginRegistrations.forgotPasswordText ||
                defaultTranslation.newLoginRegistrations.forgotPasswordText,
        },
        {
            heading:
                translation.newLoginRegistrations.checkYourEmail ||
                defaultTranslation.newLoginRegistrations.checkYourEmail,
            subHeading:
                translation.newLoginRegistrations.checkYourEmailText + ' ' + passwordSent.email ||
                defaultTranslation.newLoginRegistrations.checkYourEmailText + ' ' + passwordSent.email,
        },
    ];

    const isEmailExist = JSON.parse(localStorage.getItem('isEmailExist'));

    let pageTitle = showRecoverPasswordDialog
        ? forgotPasswordTitlesEvent[passwordSent.success ? 1 : 0]
        : loginScreenStepsTitles[isEmailExist ? 1 : userExistButNotLoggedIn ? 1 : 0];

    //handlers
    const handleIfUserExistButNotLoggedIn = () => setUserExistButNotLoggedIn(true);
    const handleResetUserExistButNotLoggedIn = () => {
        dispatch(loginUserErrorReset());
        setUserExistButNotLoggedIn(false);
    };
    const handlePasswordSent = (success, email) => {
        setPasswordSent({success: success, email: email});
    };

    const handleDialogToggle = () => {
        localStorage.removeItem('comeFrom');
        setShowRecoverPasswordDialog((prevState) => !prevState);
    };

    //page settings
    const setLanguagesData = useCallback(() => {
        const brandingTranslation = eventInfo.brandingTranslations.find(
            (translation) => translation.language === languages.eventLanguage
        );
        setBrandingTranslation(brandingTranslation);
    }, [languages.eventLanguage]);

    /*Why we have 2 useEffect, can't we handle with one?
     * We want to run dispatch(actions.setEventPublicMenu()); once.
     * But we want to run setLanguagesData() every time the languages change
     * */
    useEffect(() => {
        setLanguagesData();
    }, [languages]);

    useEffect(() => {
        dispatch(actions.setEventPublicMenu());
        setLanguagesData();
    }, []);

    useEffect(() => {
        const packageIdAndRegisterAs = localStorage.getItem('packageIdAndRegisterAs');
        if (packageIdAndRegisterAs) {
            setPreRegistrationData(JSON.parse(packageIdAndRegisterAs));
        }
    }, []);

    if (eventInfo.restrictAllUsersLogin) {
        return <Redirect to={`/event/${this.props.eventSlug}`} />;
    }
    if (loadingEvent && !eventInfo) {
        return (
            <div onDragStart={preventDefaultDrag} className="login-page-spinner-container">
                <FullPageSpinner />
            </div>
        );
    }

    return (
        <Layout
            childrenWidth={`392px`}
            brandingTranslation={brandingTranslation}
            translation={translation}
            eventInfo={eventInfo}
            isEventLogin={true}
            defaultTranslation={defaultTranslation}
            userExistButNotLoggedIn={userExistButNotLoggedIn}
            privateFnLogin={handleResetUserExistButNotLoggedIn}
            showRecoverPasswordDialog={showRecoverPasswordDialog}
        >
            <PageHeadline
                heading={pageTitle.heading}
                passwordSent={passwordSent.success}
                subHeading={pageTitle.subHeading}
            />

            {!showRecoverPasswordDialog && (
                <>
                    <SocialMedias
                        eventId={eventId}
                        registerAsExhibitor={preRegistrationData?.registerAsExhibitor || false}
                        registerAsScholar={preRegistrationData?.registerAsScholar || false}
                        registerAsParticipant={preRegistrationData?.registerAsParticipant || false}
                        preselectedAccessPackageId={preRegistrationData?.packageId || null}
                    />
                    <div className={`or-separator`}>
                        <span className={`left-line`}></span>
                        <span className={`or-text`}>
                            {translation.generalText.or || defaultTranslation.generalText.or}
                        </span>
                        <span className={`right-line`}></span>
                    </div>
                </>
            )}

            {showRecoverPasswordDialog ? (
                <ForgotPassword
                    handleDialogToggle={handleDialogToggle}
                    translation={translation}
                    defaultTranslation={defaultTranslation}
                    handlePasswordSent={handlePasswordSent}
                    passwordSent={passwordSent}
                />
            ) : (
                <LoginForm
                    handleDialogToggle={handleDialogToggle}
                    userExistButNotLoggedIn={userExistButNotLoggedIn}
                    handleIfUserExistButNotLoggedIn={handleIfUserExistButNotLoggedIn}
                />
            )}
        </Layout>
    );
};

export default LoginEvent;
